import { useDerivedServiceModeContext } from 'state/service-mode/derived';
import { PosVendors } from 'utils/vendor-config';

interface IUsePosVendor {
  vendor: PosVendors | null;
}

const usePosVendor = (): IUsePosVendor => {
  const { posVendor } = useDerivedServiceModeContext();
  return { vendor: posVendor };
};

export default usePosVendor;
